import React from 'react'
import { ToastContainer } from 'react-toastify';
import "./ToastMessageLatest.css";

const ToastMessage = () => {
    return (
        <div className="sky-toast-root">
            <ToastContainer
                position="top-center"
                autoClose={2500}
                hideProgressBar={false}
                newestOnTop
                closeOnClick
                pauseOnHover={false}
                pauseOnFocusLoss={false}
                draggable={false}
                closeButton={false}
                limit={3}
                toastClassName="small-toast"
                bodyClassName="small-toast-body"
                className="sky-toast-wrap"
            />
        </div>
    )
}

export default ToastMessage
